import React, { useState } from "react";

export default function FoodReportSelection({
  names,
  selected,
  onSave,
  onCancel,
  busy,
}) {
  const [draft, setDraft] = useState(() => new Set(selected));
  const [search, setSearch] = useState("");
  const [error, setError] = useState("");
  const save = async (event) => {
    event.preventDefault();
    setError("");
    try {
      await onSave(Array.from(draft));
    } catch {
      setError("Could not save your included foods. Please try again.");
    }
  };
  return (
    <form className="food-selection" onSubmit={save}>
      <h3>Included foods</h3>
      <p className="food-description">
        Select the food you buy from outside. Leave snacks unchecked. This
        selection applies to every month and all time.
      </p>
      <label htmlFor="food-selection-search">Find a menu item</label>
      <input
        id="food-selection-search"
        type="search"
        value={search}
        disabled={busy}
        onChange={(event) => setSearch(event.target.value)}
      />
      <div className="food-selection-list">
        {names
          .filter((name) =>
            name.toLowerCase().includes(search.trim().toLowerCase()),
          )
          .map((name) => (
            <label key={name}>
              <input
                type="checkbox"
                checked={draft.has(name)}
                disabled={busy}
                onChange={(event) => {
                  const checked = event.target.checked;
                  setDraft((previous) => {
                    const next = new Set(previous);
                    if (checked) next.add(name);
                    else next.delete(name);
                    return next;
                  });
                }}
              />
              {name}
            </label>
          ))}
        {names.length === 0 && <p>No menu items or past food orders found.</p>}
      </div>
      <p className="food-description">
        {draft.size} foods selected. If you change the foods in an order, enter
        its total cost again.
      </p>
      {error && (
        <p className="food-error" role="alert">
          {error}
        </p>
      )}
      <div className="controls-row">
        <button className="btn food-save" type="submit" disabled={busy}>
          {busy ? "Saving…" : "Save included foods"}
        </button>
        <button
          className="btn food-secondary"
          type="button"
          disabled={busy}
          onClick={onCancel}
        >
          Cancel
        </button>
      </div>
    </form>
  );
}
